import { useCallback, useRef } from 'react'

import { clampSidebarWidth } from '../../utils/chatPrefs'

type PointerHandler = (event: React.PointerEvent<HTMLButtonElement>) => void

interface ResizeHandleProps {
  onPointerDown: PointerHandler
}

export default function ResizeHandle({ onPointerDown }: ResizeHandleProps) {
  return (
    <button
      type="button"
      aria-label="Resize chat sidebar"
      onPointerDown={onPointerDown}
      className="absolute left-0 top-0 z-40 hidden h-full w-1 -translate-x-1/2 cursor-col-resize bg-transparent transition-colors hover:bg-foreground/10 active:bg-foreground/20 xl:block"
    />
  )
}

export function useStartResize(
  width: number,
  setWidth: (next: number) => void,
): PointerHandler {
  const widthRef = useRef(width)
  widthRef.current = width

  return useCallback(
    (event: React.PointerEvent<HTMLButtonElement>) => {
      event.preventDefault()
      const startX = event.clientX
      const startWidth = widthRef.current

      function handleMove(moveEvent: PointerEvent) {
        const delta = startX - moveEvent.clientX
        setWidth(clampSidebarWidth(startWidth + delta))
      }

      function handleUp() {
        window.removeEventListener('pointermove', handleMove)
        window.removeEventListener('pointerup', handleUp)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }

      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
      window.addEventListener('pointermove', handleMove)
      window.addEventListener('pointerup', handleUp)
    },
    [setWidth],
  )
}
